import classNames from 'classnames';
import { useMemo, useState } from 'react';

import { DropdownMenuProps } from './dropdown-menu.type';

export const useDropdownService = ({
  setSelectedOption,
  selectedOption,
  options,
  className,
  variant,
  labelKey,
}: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (key: string) => {
    setSelectedOption(key);
    setIsOpen(false);
  };

  const handleNativeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
  };

  const containerClasses = classNames('dropdown-wrapper', className);

  const arrowIconClasses = classNames('text-primary-400', {
    'rotate-180': isOpen,
    hidden: variant === 'ghost',
  });
  const dropdownOptionClasses = (key: string) =>
    classNames('dropdown-option', {
      'dropdown-option-selected': key === selectedOption,
    });

  const selectedLabel = useMemo(() => {
    const selected = options.find(option => option.key === selectedOption);
    if (selected) {
      return { label: selected.labelKey, styleClass: 'dropdown-content' };
    }
    if (labelKey) {
      return { label: labelKey, styleClass: 'dropdown-label' };
    }
    return {
      label: options[0]?.labelKey || '',
      styleClass: 'dropdown-content',
    };
  }, [labelKey, options, selectedOption]);

  return {
    isOpen,
    toggleDropdown,
    handleOptionClick,
    handleNativeChange,
    containerClasses,
    arrowIconClasses,
    dropdownOptionClasses,
    selectedLabel,
  };
};
